import React from 'react'
import {translate} from 'react-i18next'
import FooterLogos from './footer-logos'
import FooterOnelogLogo from './FooterOnelogLogo'
import {TopTenantSeparator} from './FooterSeparator'
import FooterView from './FooterView'
import FooterBrandsInnerView from './FooterBrandsInnerView'
import FooterLink from './FooterLink'
import Copyright from './copyright'
import FooterBrandsView from './FooterBrandsView'
import {ELEMENTS_IDS, BRANDS} from 'const'
import theme from 'theme'
import {getLang} from 'utils/stringUtils'
import {getAboutLink} from 'utils/languageUtils'
import {isLoginApp} from 'utils/envUtils'

const Footer = ({t}) => {
  const isRingier = theme.brand.name === BRANDS.onelog
  const lang = getLang(window.location.search) || 'de'
  const aboutLink = getAboutLink()

  const handleLink = e => {
    if (isRingier) {
      return
    }
    e.preventDefault()
    const {href} = e.target
    const width = window.innerWidth
    if (width > 1023) {
      return window.open(href)
    }
    window.location.href = href
  }

  return (
    <FooterView>
      <FooterBrandsInnerView>
        <TopTenantSeparator />
        <FooterBrandsView isLoginApp={isLoginApp()}>
          <FooterOnelogLogo href={aboutLink} lang={lang} />
          <hr />
          <FooterLogos logos={theme.otherBrandsLogos} />
          <FooterLink
            className={ELEMENTS_IDS.logisterPage.moreInfo}
            href={aboutLink}
            target="_blank"
            rel="noreferrer"
            onClick={handleLink}>
            {t('footer-info-button')}
          </FooterLink>
        </FooterBrandsView>
      </FooterBrandsInnerView>
      <Copyright handleLink={handleLink} />
    </FooterView>
  )
}

export {Footer as PureFooter}

export default translate()(Footer)
